// Mock data for Webmaster landing page

export const portfolioProjects = [
  {
    id: 1,
    title: "E-Commerce Premium",
    description: "Tienda online moderna con carrito de compras y pasarela de pagos",
    category: "E-Commerce",
    bgColor: "#ffd1e7",
    tags: ["Tienda Online", "Pagos", "Responsive"],
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80"
  },
  {
    id: 2,
    title: "Portal Corporativo",
    description: "Sitio web empresarial con diseño elegante y profesional",
    category: "Corporativo",
    bgColor: "#d987ff",
    tags: ["Corporativo", "Blog", "SEO"],
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
  },
  {
    id: 3,
    title: "Restaurante Gourmet",
    description: "Web para restaurante con menú digital y reservas online",
    category: "Gastronomía",
    bgColor: "#f6fd87",
    tags: ["Restaurante", "Reservas", "Menú Digital"],
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&q=80"
  },
  {
    id: 4,
    title: "Clínica Dental",
    description: "Sitio web médico con sistema de citas y galería de servicios",
    category: "Salud",
    bgColor: "#b7fbff",
    tags: ["Salud", "Citas Online", "Servicios"],
    image: "https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=800&q=80"
  },
  {
    id: 5,
    title: "Inmobiliaria Plus",
    description: "Portal inmobiliario con búsqueda avanzada y tours virtuales",
    category: "Inmobiliaria",
    bgColor: "#78d692",
    tags: ["Inmobiliaria", "Filtros", "Tours 360°"],
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80"
  },
  {
    id: 6,
    title: "Estudio Creativo",
    description: "Portfolio artístico con animaciones y galería interactiva",
    category: "Creativo",
    bgColor: "#ff965a",
    tags: ["Portfolio", "Animaciones", "Galería"],
    image: "https://images.unsplash.com/photo-1558655146-9f40138edfeb?w=800&q=80"
  }
];

export const services = [
  {
    id: 1,
    title: "Diseño Web Personalizado",
    description: "Creamos sitios web únicos adaptados a tu marca y objetivos de negocio",
    icon: "Palette",
    features: ["Diseño único", "Identidad de marca", "UX/UI profesional"]
  },
  {
    id: 2,
    title: "Desarrollo E-Commerce",
    description: "Tiendas online completas con pasarelas de pago y gestión de inventario",
    icon: "ShoppingCart",
    features: ["Carrito de compras", "Pagos seguros", "Panel de admin"]
  },
  {
    id: 3,
    title: "SEO & Optimización",
    description: "Posicionamiento en buscadores para que tus clientes te encuentren",
    icon: "Search",
    features: ["SEO On-page", "Velocidad web", "Analytics"]
  },
  {
    id: 4,
    title: "Mantenimiento Web",
    description: "Soporte continuo para mantener tu sitio actualizado y seguro",
    icon: "Shield",
    features: ["Actualizaciones", "Backups", "Soporte 24/7"]
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Starter",
    price: "S/ 299",
    description: "Ideal para emprendedores",
    bgColor: "#b6cbcb",
    features: [
      "Diseño de 1-5 páginas",
      "Responsive (móvil y tablet)",
      "Formulario de contacto",
      "Integración redes sociales",
      "SSL incluido",
      "12 meses de soporte",
      "dominio incluido 1 año",
      "hosting incluido 1 año",
      "tanto el dominio como la renovacion costo 120 soles anual"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Profesional",
    price: "S/ 1,499",
    description: "Para negocios en crecimiento",
    bgColor: "#ffd1e7",
    features: [
      "Diseño de 5-10 páginas",
      "Responsive (móvil y tablet)",
  
      "SEO básico incluido",
      "Chat en vivo",
      "12 meses de soporte",
      "Panel de administración",
  
      "Dominio incluido 1 año",
      "hosting incluido 1 año",
      "tanto el dominio como la renovacion costo 120 soles anual"
      
    ],
    popular: true
  },
  {
    id: 3,
    name: "Enterprise",
    price: "S/ 2,999",
    description: "Soluciones empresariales",
    bgColor: "#d987ff",
    features: [
      "Diseño ilimitado de páginas",
      "E-commerce completo",
      "SEO avanzado",
      "Integraciones personalizadas",
      "Capacitación incluida",
      "12 meses de soporte",
      "Hosting premium 1 año",
      "dominio incluido 1 año",
      
      "tanto el dominio como la renovacion costo 120 soles anual"
    ],
    popular: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: "María García",
    company: "Boutique Elegance",
    text: "Webmaster transformó completamente mi negocio. Mi tienda online ahora genera el 60% de mis ventas. ¡Increíble trabajo!",
    rating: 5,
    avatar: "MG"
  },
  {
    id: 2,
    name: "Carlos Rodríguez",
    company: "Constructora Norte",
    text: "Profesionales de primera. Entendieron exactamente lo que necesitaba y entregaron más de lo esperado. 100% recomendados.",
    rating: 5,
    avatar: "CR"
  },
  {
    id: 3,
    name: "Ana Torres",
    company: "Clínica Dental Smile",
    text: "El sistema de citas online ha simplificado enormemente nuestra gestión. Diseño hermoso y funcional.",
    rating: 5,
    avatar: "AT"
  }
];

export const contactInfo = {
  email: "aaranar@smartfactorychain.com",
  phone: "942149115",
  location: "Cajamarca, Perú",
  social: {
    facebook: "#",
    instagram: "#",
    linkedin: "#",
    whatsapp: "https://wa.me/51942149115"
  }
};

export const stats = [
  { value: "150+", label: "Proyectos Completados" },
  { value: "98%", label: "Clientes Satisfechos" },
  { value: "5+", label: "Años de Experiencia" },
  { value: "24/7", label: "Soporte Técnico" }
];
